import React, {  useState, useEffect } from "react";
import { Button, Modal } from 'antd';
import { Spinner } from "react-bootstrap";
import './Details.css';
import { Link, useParams, useNavigate } from "react-router-dom";
import RentabilidadesTab from "./navTabs/RentabilidadesTab";
import HistoricoTab from "./navTabs/HistoricoTab";
import Documentacion from "./navTabs/Documentacion";
import { productServices } from "../../api/services/products";

import financeIco from '../../imgs/ico-navtab-finance.png';
import historicoIco from '../../imgs/ico-navtab-historico.png';
import carteraIco from '../../imgs/ico-navtab-cartera.png';
import documentacionIco from '../../imgs/ico-navtab-documentacion.png';
import sostenibilidadIco from '../../imgs/ico-navtab-sostenibilidad.png';
import pdfIco from '../../imgs/ico-pdf.png';

const COMPARE_ID_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const COMPARE_ID_MAX_LENGTH = 25;

// Rebuilds the identifier from a fixed alphabet, so the comparator route never
// contains characters taken directly from the URL. Returns null if not valid.
const toComparableProductId = (rawProductId) => {
    const trimmedProductId = String(rawProductId ?? "").replace(/\s+/g, "");
    if (trimmedProductId.length === 0 || trimmedProductId.length > COMPARE_ID_MAX_LENGTH) {
        return null;
    }

    let comparableProductId = "";
    for (const character of trimmedProductId) {
        const alphabetPosition = COMPARE_ID_ALPHABET.indexOf(character);
        if (alphabetPosition === -1) {
            return null;
        }
        comparableProductId += COMPARE_ID_ALPHABET.charAt(alphabetPosition);
    }
    return comparableProductId;
};

const findPosition = (obj) => {
    let currenttop = 0;
    if (obj?.offsetParent) {
        do {
            currenttop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return currenttop;
    }
};

const FundDetails = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [activeSubTab, setActiveSubTab] = useState(0);
    const [showContratarModal, setShowContratarModal] = useState(false);
    const [showCalendarInfo, setShowCalendarInfo] = useState(false);
    const [showCalendarHist, setShowCalendarHist] = useState(false);

    const [selectedProductData, setSelectedProductData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();
    const { productId } = useParams();

    const handleNavigate = () => {
        const comparableProductId = toComparableProductId(productId);
        if (comparableProductId) {
            navigate(`/compare/${comparableProductId}`);
        }
    }
    const baseURLBackend = window._env_.BACKEND_ENDPOINT;
    const baseURLBackendGestor = window._env_.BACKEND_GESTOR;
    let informeProductoURL; //FONDOS
    let datosFundamentalesURL; //FONDOS
    let datosFundamentalesURLDIP; //EPSVs
    let fichaSICAVURL; //SICAV
    let datosFundamentalesParticipeURL; //PLANES
    let fichaProduPartURL; //PLANES
    let fichaProduEPSVURL; //EPSVs
    let datosFundamentalesURLKIID //SICAV

    const resolveDocUrl = (url) => {
        const u = url || '-';
        if (u === '-') return null;

        // Absoluta (http/https)
        if (/^https?:\/\//i.test(u)) return u;

        // Relativa: elegir backend según prefijo
        const base = u.startsWith('/documents/')
            ? baseURLBackendGestor
            : baseURLBackend;

        return base + u;
    };

     const getUrlByTx = (documentacion, txdesdoc) =>
         resolveDocUrl(documentacion?.find(d => d.txdesdoc === txdesdoc)?.urlcompleta);

    useEffect(() => window.scrollTo(0,0), []);

    useEffect(() => {

        const fetchDetailData = async () => {
            try {
                const productDetail = await productServices.getProductDetail(productId);
                productDetail.code !== "200" && setIsError(true);
                setSelectedProductData(productDetail.response);
            } catch (error) {
                window.scrollTo(0, 0);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };

        setIsError(false);
        setSelectedProductData(null);
        if (productId) {
            setIsLoading(true);
            fetchDetailData();
        } else {
            setIsError(true);
        }
    }, [productId]);

    //const [ productDetail, useFundDetailsContext ] = useState(0);
    // const { productDetail } = useFundDetailsContext();

    if (selectedProductData?.documentacion) {
        const { documentacion } = selectedProductData;

        // FONDOS
        informeProductoURL = getUrlByTx(documentacion, "pdfFichaProducto");
        datosFundamentalesURL = getUrlByTx(documentacion, "pdfFolletoExplicativo");

        // SICAV
        datosFundamentalesURLKIID = getUrlByTx(documentacion, "pdfFolleto");
        fichaSICAVURL = getUrlByTx(documentacion, "pdfFichaProducto");

        // EPSVs
        datosFundamentalesURLDIP = getUrlByTx(documentacion, "pdfDocumentodeInformacionPrevia");
        fichaProduEPSVURL = getUrlByTx(documentacion, "pdfFichaProducto");

        // PLANES
        datosFundamentalesParticipeURL = getUrlByTx(documentacion, "pdfDocumentoFundamental");
        fichaProduPartURL = getUrlByTx(documentacion, "pdfFichaProducto");
    }

    const getDocumentProduct = () => {
        let documentURL = "";
        if (selectedProductData && selectedProductData?.detalleproducto) {
          const mapedDocumentProduct = {
            planes: datosFundamentalesParticipeURL, //PLANES
            fondos: datosFundamentalesURL, //FONDOS
            epvs: datosFundamentalesURLDIP, //EPSVs
            sicav: datosFundamentalesURLKIID, //SICAV
          };

  
          documentURL = selectedProductData?.detalleproducto?.tipo
            ? mapedDocumentProduct[selectedProductData?.detalleproducto?.tipo]
            : "";
        }

        return documentURL;
      };

      const getDocumentProductCartera = () => {
        let documentURL = "";
        if (selectedProductData && selectedProductData?.detalleproducto) {
          const mapedDocumentProduct = {
            planes: fichaProduPartURL, //PLANES
            fondos: informeProductoURL, //FONDOS
            epvs: fichaProduEPSVURL, //EPSVs
            sicav: fichaSICAVURL, //SICAV
          };
  
          documentURL = selectedProductData?.detalleproducto?.tipo
            ? mapedDocumentProduct[selectedProductData?.detalleproducto?.tipo]
            : "";
        }
  
        return documentURL;
      };

    const navTabs = [
        {
            text: 'Información y rentabilidades',
            component: <RentabilidadesTab
                            showCalendarInfo={showCalendarInfo}
                            setShowCalendarInfo={(e) => setShowCalendarInfo(e)}
                            selectedProduct={selectedProductData}
                        ></RentabilidadesTab>,
            subTabs: [
                { title: 'Datos generales', url: 'datos' },
                { title: 'Información en Materia de Sostenibilidad', url: 'producto' },
                { title: 'Resumen de rentabilidades', url: 'resumen' },
                { title: 'Gestor', url: 'gestor' }
            ],
            icon: financeIco,
        },
        {
            text: 'Histórico de rentabilidades',
            component: <HistoricoTab
                            selectedProduct={selectedProductData}
                            showCalendarHist={showCalendarHist}
                            setShowCalendarHist={(e) => setShowCalendarHist(e)}
                        ></HistoricoTab>,
            icon: historicoIco,
        },
        {
            //FONDOS
            text: 'Información de cartera',
            component: <div className="mt-4">
                {
                    (informeProductoURL != null && informeProductoURL !== (baseURLBackend + "-" && getDocumentProductCartera() != null) ? 
                        <p className="text-cartera">Para consultar esta información acceda a la 
                            <a target="_blank" rel="noreferrer" href={getDocumentProductCartera()} style={{textTransform: "initial", color: 'red'}} > Ficha de Seguimiento 
                            </a> 
                        </p> : "" )
                }
                           
                        </div>,
            icon: carteraIco,
        },
        //{
        //    text: 'Top 10',
        //    component: <div className="mt-4">
        //                    <p>Para consultar esta información acceda a la 
        //                        <a target="_blank" href="https://www.santanderassetmanagement.es/buscadorproductosback/file/concatPdf/?ids=pdfFichaProdIngl&ids=pdfFichaProducto&ids=pdfFolletoExplicativo&ids=pdfInformeSemestralext&codProd=CL0000058" style={{textTransform: "initial", color: 'red'}}> Información de Producto</a>
        //                    </p>
        //                </div>,
        //    icon: carteraIco,
        //},
        {
            text: 'Documentación',
            component: <Documentacion
                        selectedProduct={selectedProductData}
                        ></Documentacion>,
            icon: documentacionIco,
        }
    ];
    
    const botonContratar = () => {
        let event1 = {
            "event": "en_click",
            "ep_view_name": selectedProductData?.detalleproducto?.nombre,
            "ep_user_id": "",
            "ep_user_type": "",
            "ep_action_detail": "Como contratar", 
            "ep_element_type": "button",
            "ep_destination_url": "" 
        };
        (window.dataLayer = window.dataLayer || []).push(event1);
    }
    
    const getTypeInitials = () => {
      let typeName = "";
      if (selectedProductData && selectedProductData?.detalleproducto) {
        const mapedType = {
          planes: "(DDFP)",
          fondos: "(DDF)",
          epvs: "(DIP)",
          sicav: "(KID)",
        };

        typeName = selectedProductData?.detalleproducto?.tipo
          ? mapedType[selectedProductData?.detalleproducto?.tipo]
          : "";
      }

      return typeName;
    };
    
    return(
        <section data-testid="pagina-detalles" style={{marginTop: 20}} onClick={(e) => {
                if((!e.target.classList.value.includes('react-calendar') && !e.target.parentElement.classList.value.includes('react-calendar')) && (showCalendarHist || showCalendarInfo)) {
                    setShowCalendarHist(false);
                    setShowCalendarInfo(false);
                }
            }}>
            <div className="container">
                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="alert alert-danger" role="alert">
                            <Spinner animation="border" variant="danger" role="status" className="me-2"/>
                            Cargando...
                        </div>
                    </div>
                )}
                {!isLoading && (
                    <>
                        <div style={{fontSize: 14, marginBottom: 40}}>
                            <Link to={`/`}>
                                <span style={{cursor: 'pointer'}}>Inicio </span>
                            </Link>
                            {">"}
                            <span style={{color: '#585858'}}> Consulta</span>
                        </div>
                        {isError && (
                            <div className="alert alert-danger mt-3" role="alert">Se ha producido un error, vuelve a intentarlo</div>
                        )}
                        <Modal
                            className="modalShadowBox searcher-funds-react23"
                            title={<div style={{display: 'flex', justifyContent: 'center', marginTop: 15}}>
                                <span className="blueText" style={{fontWeight: 600, fontSize: 20, margin: 'auto'}}>Cómo contratar</span>
                            </div>}
                            open={showContratarModal}
                            onCancel={() => {setShowContratarModal(false)}}
                            footer={null}
                            closeIcon={<i className="fa-solid fa-x" style={{color: 'red'}}></i>}
                            >
                            <div>
                                <p className="modalText modal-parraf">
                                    Si no es cliente, conozca las ventajas que le ofrece Banco Santander
                                </p>
                                <ul>
                                    <li>De forma online <a style={{color: '#ec0000'}} href="https://www.bancosantander.es" rel="noreferrer" target="_blank">www.bancosantander.es</a></li>
                                    <li>En su <a style={{color: '#ec0000'}} href="https://www.bancosantander.es/cssa/Satellite?pagename=BuscadorOficinas/Page/BOF_FrontEnd&empr=Santander&leng=es_ES">oficina</a> más cercana</li>
                                </ul>
                                <p className="modalText modal-parraf">
                                    Si ya es cliente de Banco Santander, acceda a través de su área privada en <a style={{color: '#ec0000'}} href="https://particulares.bancosantander.es/login/?entrada_por=C0873" rel="noreferrer" target="_blank">este enlace</a> o acuda a su oficina mas cercana.
                                </p>
                                <p className="modalText modal-parraf">
                                    Si es cliente de otro comercializador acceda a través de su área privada.
                                </p>
                            </div>
                            <div style={{height: 40, display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => setShowContratarModal(false)} className="infoButton">OK</button>
                            </div>
                        </Modal>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div style={{display: 'flex'}}>
                                    <h2 style={{fontSize: 20}} className="blueText bold700">
                                        {selectedProductData?.detalleproducto?.nombre}
                                    </h2>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'space-between', maxWidth: 550, fontSize: 16}}>
                                    <div className="semibold blueText">{(selectedProductData?.detalleproducto?.isin) ? (`ISIN: ${selectedProductData?.detalleproducto?.isin}`) : (`Código: ${selectedProductData?.detalleproducto?.codigoDgs}`)}</div>
                                    <div style={{fontSize: 16, marginLeft: 10, marginRight: 10}} className="semibold blueText">|</div>
                                    <div className="semibold blueText">
                                        <span style={{marginRight: 20}}>Otras clases:</span>
                                        {
                                            selectedProductData && selectedProductData?.productoshermanos?.map((e, idx) =>
                                            <Link to={`/id/${e.isin ? e.isin : e.codigoDgs}`} key={idx}>
                                                <span key={idx}>
                                                    <span style={{color: 'red', cursor: 'pointer'}}>{e.clase}</span>
                                                    {idx < selectedProductData.productoshermanos.length -1 && <span style={{ marginLeft: 10, marginRight: 10}}>|</span>}
                                                </span>
                                            </Link>
                                            )
                                        }
                                    </div>
                                </div>
                                <div style={{marginTop: 20, marginLeft:5}}>
                                    <Button onClick={() => { setShowContratarModal(true); botonContratar();}} type="primary" shape="round" style={{fontWeight: 600, backgroundColor: 'red', color: 'white', borderColor: 'red', paddingLeft: 50, paddingRight: 50, marginLeft: 10}}>
                                        Cómo contratar
                                    </Button>
                                    <Button onClick={() => navigate("/")} type="primary" shape="round" style={{fontWeight: 600, backgroundColor: 'red', color: 'white', borderColor: 'red', paddingLeft: 50, paddingRight: 50, marginLeft: 10}}>
                                        Volver al buscador
                                    </Button>
                                </div>
                                </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div style={{display: 'flex', justifyContent: 'end'}}>
                                    <div data-testid="boton-comparador" className="nav-boxtop" onClick={handleNavigate}>
                                        <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={financeIco} alt="Icono Comparador de productos"/>
                                        <span>Comparador de productos</span>
                                    </div>
                                    <div>
                                    {
                                        //FONDOS
                                        (datosFundamentalesURL != null && datosFundamentalesURL !== (baseURLBackend + "-") && getDocumentProduct() != null && getDocumentProduct() !== "" && selectedProductData?.detalleproducto?.tipo === 'fondos' ? 
                                            <div className="nav-boxtop">
                                                
                                                <a style={{color: 'inherit'}} href={getDocumentProduct()} target="_blank" rel="noreferrer">
                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="Icono Informe (DFF)"/>
                                                    <span>Informe {getTypeInitials()}</span>
                                                </a>
                                            </div>
                                        : ""
                                        )
                                    }
                                    </div>
                                    <div>
                                    {
                                        //SICAV
                                        (datosFundamentalesURLKIID != null && datosFundamentalesURLKIID !== (baseURLBackend + "-") && getDocumentProduct() != null && getDocumentProduct() !== "" && selectedProductData?.detalleproducto?.tipo === 'sicav' ? 
                                            <div className="nav-boxtop">
                                                
                                                <a style={{color: 'inherit'}} href={getDocumentProduct()} target="_blank" rel="noreferrer">
                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="Icono Informe (KIID))"/>
                                                    <span>Informe {getTypeInitials()}</span>
                                                </a>
                                            </div>
                                        : ""
                                        )
                                    }
                                    </div>
                                    <div>
                                    {
                                        //EPSVs
                                        (datosFundamentalesURLDIP != null && datosFundamentalesURLDIP !== (baseURLBackend + "-") && getDocumentProduct() != null&& getDocumentProduct() !== "" && selectedProductData?.detalleproducto?.tipo === 'epvs' ? 
                                            <div className="nav-boxtop">
                                                
                                                <a style={{color: 'inherit'}} href={getDocumentProduct()} target="_blank" rel="noreferrer">
                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="Icono Informe (DIP)"/>
                                                    <span>Informe {getTypeInitials()}</span>
                                                </a>
                                            </div>
                                        : ""
                                        )
                                    }
                                    </div>
                                    <div>
                                    {
                                        //PLANES
                                        (datosFundamentalesParticipeURL != null && datosFundamentalesParticipeURL !== (baseURLBackend + "-") && getDocumentProduct() != null && getDocumentProduct() !== "" && selectedProductData?.detalleproducto?.tipo === 'planes' ? 
                                            <div className="nav-boxtop">
                                                
                                                <a style={{color: 'inherit'}} href={getDocumentProduct()} target="_blank" rel="noreferrer">
                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="Icono Informe (DDFP)"/>
                                                    <span>Informe {getTypeInitials()}</span>
                                                </a>
                                            </div>
                                        : ""
                                        )
                                    }
                                    </div>
                                    <div>
                                        {
                                            //FONDOS
                                            (informeProductoURL != null && informeProductoURL !== "-" ? 
                                                <div className="nav-boxtop">
                                                    <a style={{color: 'inherit'}} href={informeProductoURL} target="_blank" rel="noreferrer">
                                                        <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="Icono Información del producto"/>
                                                        <span>Información del producto</span>
                                                    </a>
                                                </div>
                                            : ""
                                            )
                                        }
                                    </div>
                                    {(selectedProductData != null && selectedProductData.detalleproducto != null && selectedProductData.detalleproducto?.url != null) && (
                                        <div className="nav-boxtop">
                                            <a style={{color: 'inherit'}} href={selectedProductData.detalleproducto?.url} target="_blank" rel="noreferrer">
                                                <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={sostenibilidadIco} alt="Icono Información en Materia de sostenibilidad"/>
                                                <span>Inf. en Materia de Sostenibilidad</span>
                                            </a>
                                        </div>
                                     )}
                                </div>
                            </div>
                            <div className="row col-lg-12 col-md-12 col-sm-12 mt-md-3">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <ul className="searcher-nav-list">
                                        {
                                            navTabs.map((e, idx) =>
                                                <div key={idx}>
                                                    <li className="searcher-nav-item">
                                                        <a 
                                                            className="searcher-nav-link"
                                                            href="#top"
                                                            role="button"
                                                            style={{color: activeTab === idx ? 'red' : 'black'}}
                                                        >
                                                            <span
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setActiveTab(idx);
                                                                    setActiveSubTab(0);
                                                                }}
                                                            >
                                                                <img style={{marginRight: 10, position: 'relative', marginBottom: 10}} src={e.icon} alt="icon"/>
                                                                <span style={{bottom: 3, position: 'relative'}}>{e.text}</span>
                                                            </span>
                                                            {
                                                                (activeTab === idx && e.subTabs && e.subTabs.length) && (
                                                                <ul className="searcher-nav-list--submenu">
                                                                {
                                                                    activeTab === idx && e.subTabs && e.subTabs.map((subTab, idx2) => {
                                                                        if (subTab.url === "producto" && selectedProductData?.detalleproducto?.url == null && selectedProductData?.detalleproducto?.sostenibilidad == null) return <></>;
                                                                        return (
                                                                            <li
                                                                                className="searcher-nav-item--submenu button-box"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setActiveSubTab(idx2);
                                                                                    window.scrollTo(0,findPosition(document.getElementById(subTab.url)));
                                                                                }}
                                                                                key={idx2}
                                                                                style={{
                                                                                    maxWidth: 'inherit',
                                                                                    textAlign: 'left',
                                                                                    fontSize: 16,
                                                                                    fontWeight: 600,
                                                                                    border: 0,
                                                                                    backgroundColor: activeSubTab === idx2 ? '#f0f0f0' : 'white',
                                                                                    color: activeSubTab === idx2 ? 'red' : 'black'
                                                                                }}
                                                                            >
                                                                                {subTab.title}
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                                </ul>
                                                                )
                                                            }                                                        
                                                        </a>
                                                    </li>

                                                    {/* <div onClick={() => {setActiveTab(idx); setActiveSubTab(0);}} 
                                                        className="button-box" style={{
                                                        maxWidth: 'inherit',
                                                        textAlign: 'left',
                                                        fontSize: 16,
                                                        fontWeight: 600,
                                                        height: 60,
                                                        color: !e.subTabs && activeTab === idx ? 'red' : 'black',
                                                        backgroundColor: activeTab === idx ? '#f0f0f0' : 'white'}}>
                                                        <img style={{marginRight: 10, position: 'relative', marginBottom: 10}} src={e.icon}/>
                                                        <span style={{bottom: 3, position: 'relative'}}>{e.text}</span>
                                                    </div> */}
                                                    {/*activeTab === idx && e.subTabs &&
                                                        e.subTabs.map((subTab, idx) =>
                                                            <div onClick={() => {
                                                                setActiveSubTab(idx);
                                                                window.scrollTo(0,findPosition(document.getElementById(subTab.url)));
                                                            }} key={idx} className="button-box" style={{
                                                                maxWidth: 'inherit',
                                                                textAlign: 'left',
                                                                fontSize: 16,
                                                                fontWeight: 600,
                                                                border: 0,
                                                                backgroundColor: activeSubTab === idx ? '#f0f0f0' : 'white',
                                                                color: activeSubTab === idx ? 'red' : 'black'}}>
                                                                    {subTab.title}
                                                            </div>
                                                        )
                                                    */}
                                                </div>
                                            )
                                        }
                                        </ul>      
                                        {(selectedProductData != null && selectedProductData.detalleproducto != null && selectedProductData.detalleproducto?.url != null &&                       
                                            <div className="searcher-nav-item">
                                                <a className="searcher-nav-link" href={selectedProductData.detalleproducto?.url} target="_blank" rel="noreferrer">
                                                        <img style={{marginRight: 10, position: 'relative', marginBottom: 10}} src={sostenibilidadIco} alt="icono sostenible"/>
                                                        <span style={{bottom: 3, position: 'relative'}}>Información en Materia de Sostenibilidad</span>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        {navTabs[activeTab].component}
                                    </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default FundDetails;
